<div>
  <div class="pt-3">
    An error occurred while processing your request.
    <div class="pt-3">
      Reported Error:
    </div>
    <div class="text-danger">
      {{errorMessage}}{{inputErrorMessage}}</div>
    </div>
  <div class="pt-3">
    To continue use an option on the menu above or
    <a class="link cursorPointer" (click)="ReturnToProjectList()">return to project list.</a>
  </div>
  <div *ngIf="errorId!==null">
     <a class="link cursorPointer" (click)="EmailAdmin()" title=" Email your system administrator details about this error.">Notify your site administrator</a>
  </div>
</div>









